module.exports = __webpack_public_path__ + "components/flag/static/square/id-9618363b011b0c7102d94481540690f6.svg";